// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"hg","itemsContainer":"ig"};